import type {InventoryStem} from '@/domain/entities/InventoryStem';
import type {InventoryStemDto} from './InventoryStemDto';

export const toDto = (domain: InventoryStem): InventoryStemDto => ({
  uuid: domain.uuid,
  inventoryPlotUuid: domain.inventoryPlotUuid,
  diameterInMm: domain.diameterInMm,
  height: domain.height,
  volumeUsc: domain.volumeUsc,
  volumeIfn: domain.volumeIfn,
});

export const toDomain = (dto: InventoryStemDto): InventoryStem => ({
  ...dto,
});
